import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { DataTaskService } from '@app/core/services/data-task.service';
import { RememberService } from '@app/core/services/remember.service';

@Component({
    selector: 'tt-project-folders',
    templateUrl: './project-folders.component.html',
    styleUrls: ['./project-folders.component.css'],
})
export class ProjectFoldersComponent implements OnChanges {
    @Input()
    params?: GetProjectFoldersParams;

    public get?: ProjectFoldersGet;

    folders: any[] = [];

    @Output()
    getLoaded = new EventEmitter<ProjectFoldersGet>();

    constructor(private datatask: DataTaskService, private remember: RememberService) {}

    public onFolderSelected(event: any) {
        if (!!this.get) {
            this.get.item_id_selected = event[0].item_id;
            this.get.item_name_selected = event[0].item_name;
            this.get.item_type_selected = event[0].item_type;

            this.remember.remember('w_projectfolders.item_id_selected.' + this.get.project_keyno, this.get.item_id_selected);
            this.remember.remember('w_projectfolders.item_name_selected.' + this.get.project_keyno, this.get.item_name_selected);
            this.remember.remember('w_projectfolders.item_type_selected.' + this.get.project_keyno, this.get.item_type_selected);

            this.get = { ...this.get };
        }
    }

    public onListUpdated() {
        this.datatask.Post(3840, { records: this.folders });
    }

    private async loadGet() {
        if (!!this.params) {
            this.get = await this.getProjectFoldersPage(this.params);
            this.getLoaded.emit(this.get);
        }
    }

    public async selectNextTreeItem() {
        if (!this.get) return;

        const index = this.folders.findIndex((item) => '' + item.item_id === '' + this.get!.item_id_selected);

        await this.loadFolders();

        // this.get.item_id_selected = this.folders[index - 1]?.item_id;

        this.onFolderSelected([this.folders[index - 1]]);
    }

    public async loadFolders() {
        if (!!this.get) {
            this.folders = (await this.getFolders(this.get)).map((item: any) => ({ ...item, item_nestable: '1' }));
        }
    }

    /**
     *
     * @datatask 3833
     * @datataskName sp_ws_p2_w_projectfolders_get
     * @param params the project keyno to get folders for.
     * @returns the get.
     */
    private async getProjectFoldersPage(params: GetProjectFoldersParams) {
        return (await this.datatask.Post(3833, params))[0];
    }

    private async getFolders(get: ProjectFoldersGet): Promise<any> {
        return this.datatask.Post(3834, get);
    }

    public async init() {
        await this.loadGet();
        this.loadFolders();
    }

    ngOnChanges(changes: SimpleChanges): void {
        console.log(changes);
        this.init();
    }
}

export interface GetProjectFoldersParams {
    project_keyno: string | number;
}

export interface ProjectFoldersGet {
    webpage_heading: string;
    project_keyno: `${number}`;
    show_setting: '1' | '0';
    item_id_selected: string;
    item_name_selected: string;
    item_type_selected: string;
}
